import { render } from "./SectionWrapper.vue?vue&type=template&id=317f1fd6&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"

import "./SectionWrapper.vue?vue&type=style&index=0&id=317f1fd6&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317f1fd6"]])

export default __exports__